import { Campaign, CampaignCounts } from '@models/Campaign'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { CAMPAIGN_URL } from '@utils/urls'

const fetchCampaigns = (params: TableParams) =>
  SBAPI.FetchPaginated<Campaign[]>(CAMPAIGN_URL, params)

const fetchCampaignById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Campaign>(`${CAMPAIGN_URL}/${id}`, params)

const fetchCampaignCountsById = (id: number, params: TableParams) =>
  SBAPI.Fetch<CampaignCounts>(`${CAMPAIGN_URL}/${id}/counts`, params)

const createCampaign = (campaign: Campaign) =>
  SBAPI.Post(CAMPAIGN_URL, campaign)

const updateCampaign = (campaign: Campaign) =>
  SBAPI.Put(`${CAMPAIGN_URL}/${campaign.id}`, campaign)

const deleteCampaign = (campaign: Campaign) =>
  SBAPI.Delete(`${CAMPAIGN_URL}/${campaign.id}`)

export {
  createCampaign,
  deleteCampaign,
  fetchCampaignById,
  fetchCampaignCountsById,
  fetchCampaigns,
  updateCampaign,
}
